import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import FormControl from 'components/Form/FormControl'

import styles from './styles.module.scss'

const RateBox = ({ editStepRate, stepId, value }) => {
  const normalizedValue = useMemo(() => {
    return Number.isInteger(value) && value >= 1 && value <= 10
      ? String(value)
      : ''
  }, [value])

  const onChange = e => {
    const raw = e.target.value
    if (raw === '') {
      editStepRate({ stepId, rate: null })
      return
    }
    const next = Number(raw)
    if (!Number.isInteger(next) || next < 1 || next > 10) return
    editStepRate({ stepId, rate: next })
  }

  return (
    <FormControl
      name="rate"
      as="select"
      className={styles.rateBox}
      formGroupClass="mb-0"
      value={normalizedValue}
      onChange={onChange}
    >
      <option value="">—</option>
      {Array.from({ length: 10 }).map((_, idx) => {
        const v = String(idx + 1)
        return (
          <option key={v} value={v}>
            {v}
          </option>
        )
      })}
    </FormControl>
  )
}

RateBox.propTypes = {
  editStepRate: PropTypes.func,
  stepId: PropTypes.number,
  value: PropTypes.number
}

export default RateBox
